export interface ILocationRequirement {
  _id?: string;
  continent?: string;
  country?: string[];
}

export class LocationRequirement implements ILocationRequirement {
  _id?: string;
  continent: string;
  country: string[];

  constructor( requirement: ILocationRequirement = {} ) {
    this._id = requirement._id;
    this.continent = requirement.continent;
    this.country = requirement.country || [];
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/location-requirement.ts